import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
type FirstFieldsTextProps = {
  fields: string[];
  hasCollapsedFields?: boolean;
};
const FieldName = t0 => {
  const $ = _c(2);
  const {
    field
  } = t0;
  let t1;
  if ($[0] !== field) {
    t1 = field.startsWith("di.") || field.includes(".") ? <span className="text-snippet-2">{field}</span> : field;
    $[0] = field;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};

// NOTE: each field is its own <p> so the parent container can wrap them across
// multiple lines, and so the code style covers the field alone, not the connectors
const FirstFieldsText = t0 => {
  const $ = _c(25);
  const {
    fields,
    hasCollapsedFields
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.userData"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  if (fields.length === 0) {
    return null;
  }
  if (hasCollapsedFields) {
    let t2;
    if ($[1] !== fields) {
      t2 = fields.map(_temp);
      $[1] = fields;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t) {
      t3 = t(_temp2);
      $[3] = t;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== t3) {
      t4 = <p data-testid="field" className="wrap-anywhere text-label-2 md:break-words">{t3}</p>;
      $[5] = t3;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== t2 || $[8] !== t4) {
      t5 = <>{t2}{t4}</>;
      $[7] = t2;
      $[8] = t4;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    return t5;
  }
  let firstFields;
  let lastField;
  let t2;
  if ($[10] !== fields) {
    firstFields = fields.slice(0, -1);
    lastField = fields[fields.length - 1];
    t2 = firstFields.map(field_0 => <p data-testid="field" className="wrap-anywhere text-label-2 md:break-words" key={field_0}><FieldName field={field_0} />{firstFields.length > 1 ? "," : ""}</p>);
    $[10] = fields;
    $[11] = firstFields;
    $[12] = lastField;
    $[13] = t2;
  } else {
    firstFields = $[11];
    lastField = $[12];
    t2 = $[13];
  }
  let t3;
  if ($[14] !== firstFields.length || $[15] !== t) {
    t3 = firstFields.length > 0 ? `${t(_temp3)} ` : "";
    $[14] = firstFields.length;
    $[15] = t;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== lastField) {
    t4 = <FieldName field={lastField} />;
    $[17] = lastField;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== t3 || $[20] !== t4) {
    t5 = <p data-testid="field" className="wrap-anywhere text-label-2 md:break-words">{t3}{t4}</p>;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== t2 || $[23] !== t5) {
    t6 = <>{t2}{t5}</>;
    $[22] = t2;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
};
export default FirstFieldsText;
function _temp(field) {
  return <p data-testid="field" className="wrap-anywhere text-label-2 md:break-words" key={field}><FieldName field={field} />,</p>;
}
function _temp2($) {
  return $.and;
}
function _temp3($_0) {
  return $_0.and;
}